import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class ServiceProvidersManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/service-providers',
      params,
      paramsSerializer: qs.stringify,
    });

  /**
   * Acts on the on-behalf-of service provider; an explicit id overrides the
   * sidebar selection so the Partners page can edit any partner.
   */
  update = (data, serviceProviderId = undefined) =>
    this.request({
      method: 'POST',
      url: '/service-providers',
      data,
      ...(serviceProviderId && { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } }),
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/partners',
      data,
    });

  regionalConfigs = () =>
    this.request({
      method: 'GET',
      url: '/partners/regional-configs',
    });

  import = (file) => {
    const data = new FormData();
    data.append('file', file);

    return this.request({
      method: 'POST',
      url: '/partners/import',
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  };

  suspend = (id) =>
    this.request({
      method: 'POST',
      url: `/partners/${id}/suspend`,
    });

  unsuspend = (id) =>
    this.request({
      method: 'POST',
      url: `/partners/${id}/unsuspend`,
    });
}
